class CartFreeShippingProgress extends HTMLElement {
  #unsubscriber = null;

  connectedCallback() {
    this.#unsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.#onCartUpdate.bind(this));
    this.#syncBar();
  }

  disconnectedCallback() {
    if (this.#unsubscriber) {
      this.#unsubscriber();
      this.#unsubscriber = null;
    }
  }

  #onCartUpdate(event) {
    const totalPrice = event?.cartData?.total_price;
    if (typeof totalPrice !== 'number') return;
    this.dataset.cartTotalCents = String(totalPrice);
    this.#syncBar();
  }

  #syncBar() {
    const threshold = parseInt(this.dataset.thresholdCents || '0', 10);
    const total = parseInt(this.dataset.cartTotalCents || '0', 10);
    if (threshold <= 0) return;

    const fill = this.querySelector('.cart-free-shipping__fill');
    const track = this.querySelector('.cart-free-shipping__track');
    if (!fill || !track) return;

    const pct = Math.min(100, Math.round((total / threshold) * 100));
    fill.style.width = `${pct}%`;
    track.setAttribute('aria-valuenow', String(pct));
  }
}

if (!customElements.get('cart-free-shipping-progress')) {
  customElements.define('cart-free-shipping-progress', CartFreeShippingProgress);
}
